import axios from 'axios';
import _ from 'lodash';
import { GetRegion } from 'constants.js';
import { getHKS, setHKS } from 'utils/HKS';
import { getBrowser } from 'utils/Platform';
import qs from 'qs';
import { getUserId } from 'utils/User';
import { store } from 'store.js';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import { HttpClient } from 'api/helpers/HttpClient';
import { getUrlParamsFromWorkflowstart} from 'utils/getUrlParamsWorkflowstart';
import { getMissingParamsFromUrl } from 'utils/getMissingParams';
import { getComplementParams } from 'utils/getQueryParams';

const api = axios.create({ baseURL: process.env.URL_DOMINIO_MICROFWK });
const configPost = {
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  },
};

export const updateDefaults = async (axiosInstance, properties = {}) => {
  const instance = axiosInstance;
  const props = {};
  _.assign(props, properties);
  props.params.region = GetRegion();
  props.params.HKS = getHKS();
  // invariant
  await _.merge(instance.defaults, props);
  return instance;
};

export const postExecute = (url, params) =>
  api
    .post(url, qs.stringify(params), { ...configPost })
    .then(({ data }) => data)
    .catch(({ response }) => {
      const errors = _.get(
        response,
        'data.errors.0',
        _.get(response, 'data.errors', {}),
      );
      return {
        ...errors,
        status: response.status,
      };
    });

export const postExecutePGM = (url, formData) => {
  const defaultParams = {
    ...window.getConfig.config.general.api_params_default,
  };
  delete defaultParams.api_version;
  delete defaultParams.device_id;
  defaultParams.region = GetRegion();
  defaultParams.HKS = getHKS();
  return axios
    .post(
      `${process.env.URL_DOMINIO_MICROFWK}${url}&${qs.stringify(
        defaultParams,
      )}`,
      formData,
      { ...configPost },
    )
    .then(response => response)
    .catch(response => response);
};

export const customPostExecute = (url, params, deleteApiVersion = false) => {
  const customParams = qs.parse(url);
  if (window.getConfig.api_version !== customParams.api_version) {
    let defaultParams = {
      ...window.getConfig.config.general.api_params_default,
      device_so: getBrowser(),
      HKS: getHKS(),
      region: GetRegion(),
      user_id: getUserId(),
    };

    if (deleteApiVersion) delete defaultParams.api_version;

    Object.keys(customParams).forEach(param => {
      delete defaultParams[param];
    });

    return axios
      .post(
        `${process.env.URL_DOMINIO_MICROFWK}${url}`,
        qs.stringify(params),
        { params: defaultParams },
        { ...configPost },
      )
      .then(({ data }) => {
        return data;
      })
      .catch(({ response }) => {
        return {
          ...response.data,
        };
      });
  } else {
    return api
      .post(url, qs.stringify(params), { ...configPost })
      .then(({ data }) => data)
      .catch(({ response }) => {
        const errors = _.get(
          response,
          'data.errors.0',
          _.get(response, 'data.errors', {}),
        );
        return {
          ...errors,
          status: response.status,
        };
      });
  }
};


export const customGetExecute = (url, params = {}, isVersionPath) => {
  const defaultParams = {
    ...window.getConfig.config.general.api_params_default,
  };
  if (isVersionPath) {
    const { token } =
      JSON.parse(localStorage.getItem('loginInfo.logged_user_data') || '') ||
      '';
    axios.defaults.headers['user-token'] = token;
  } else {
    delete axios.defaults.headers['user-token'];
  }
  delete defaultParams.api_version;
  defaultParams.region = GetRegion();
  defaultParams.HKS = getHKS();
  const { missingParams } = getMissingParamsFromUrl(url, defaultParams);
  return axios
    .get(
      `${process.env.URL_DOMINIO_MICROFWK}${url}&${qs.stringify(
        missingParams,
      )}&${qs.stringify(params)}`,
    )
    .then(response => {
      if (isVersionPath) return response.data;
      return response;
    })
    .catch(response => {
      if (isVersionPath)
        return {
          ...response?.response?.data?.errors,
          status: response?.response?.status,
        };
      return response;
    });
};

export const getExecute = (url, params = {}, isVersionPath = false) => {
  if (!isVersionPath) {
    const { allQueryParams, serviceUrl } = getComplementParams(url, api.defaults.params, params )

    return api
      .get(serviceUrl, allQueryParams)
      .then(({ data }) => {
        return data;
      })
      .catch(({ response }) => ({
        ...response.data?.errors,
        status: response.status,
      }));
  }
  return customGetExecute(url, params, isVersionPath);
};

export const getPurchaseButton = (params = {}) =>
  api
    .get('services/payway/purchasebuttoninfo', { params })
    .then(({ data }) => data);

export const getWorkflowStart = (endpoint, params = {}) =>{
  const isClaroAdsActive = getClaroAdsKey(store.getState())
  const apiCall = new HttpClient({hasClaroAdActive : isClaroAdsActive})
  const { url, paramsObject } = getUrlParamsFromWorkflowstart(endpoint)
  return apiCall.get(url, { params, ... paramsObject }).then(({ data }) => data);
}
  

export const getSearchVertical = (params = {}) =>
  api.get('services/search/vertical', { params }).then(({ data }) => data);

export const getNavData = (params = {}) =>
  api.get('services/nav/data', { params }).then(({ data }) => data);

export const getStartHeaderInfos = HKS => {
  const params = {
    device_id: 'web',
    device_category: 'web',
    device_manufacturer: 'generic',
    device_model: 'web',
    device_type: 'web',
    api_version: 'v5.93',
    authpn: 'webclient',
    authpt: 'tfg1h3j4k6fd7',
    format: 'json',
    device_so: getBrowser(),
    HKS,
  };
  return api
    .get('services/user/startheaderinfo', {
      params,
    })
    .then(({ data }) => data);
};

export const getApaMetadata = params =>
  api
    .get('services/apa/metadata', {
      params: {
        ...params,
        device_so: getBrowser(),
      },
    })
    .then(({ data }) => data);

export const getApaAssets = params =>
  api
    .get('services/apa/asset', {
      params: {
        ...params,
        device_so: getBrowser(),
      },
    })
    .then(({ data }) => data);

export default api;
